import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, inject, onMounted } from 'vue'
import { ComputedPaymentProfile, TableViewPaymentProfile } from '../models/dto'
import paymentProfileService from '../services/paymentProfile'
import auth from '../store/modules/auth'
import PaymentProfileV2 from '@/components/PaymentProfileV2.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentProfileSelectorV2',
  props: {
    quoteId: null,
    reservationManagedId: null
  },
  emits: [
  'input',
  'update:has-payment-profiles',
  'update:loading'
],
  setup(__props: any, { emit }) {

const props = __props as {
  quoteId?: number | null
  reservationManagedId?: string | null
};

const isInGuestCheckout = inject('isInGuestCheckout', false)
const isInBilling = inject('isInBilling', false)
const isLoading = ref(false)





const paymentProfiles = ref<ComputedPaymentProfile[]>([])
const selectedPaymentProfileId = ref<number | null>(null)

watch(selectedPaymentProfileId, () => {
  const selectedPaymentProfile =
    paymentProfiles.value.find(
      ({ customerPaymentProfileId }) =>
        customerPaymentProfileId === selectedPaymentProfileId.value
    ) || null
  emit('input', selectedPaymentProfile)
})

const setPaymentProfiles = async () => {
  if (isInGuestCheckout && !auth.user) {
    emit('update:has-payment-profiles', false)
    emit('update:loading', false)
    return
  }
  await loadSavedCustomerPaymentProfiles()
  await selectDefaultOrFirstPaymentProfile()
}

onMounted(async () => {
  await setPaymentProfiles()
})

const loadSavedCustomerPaymentProfiles = async () => {
  emit('update:loading', true)
  isLoading.value = true
  const { data } = await paymentProfileService.loadSavedCustomerPaymentProfiles(auth.userId)
  const paymentProfilesResults = data?.resultList || []
  paymentProfiles.value = paymentProfilesResults.map((profile: TableViewPaymentProfile) =>
    processPaymentProfile(profile)
  )
  emit('update:has-payment-profiles', !!paymentProfiles.value?.length)
  isLoading.value = false
  emit('update:loading', false)
}

const selectDefaultOrFirstPaymentProfile = async () => {
  if (!paymentProfiles.value?.length) {
    return
  } else {
    const defaultProfileId = paymentProfiles.value.find(
      ({ isDefault }) => isDefault
    )?.customerPaymentProfileId
    const firstProfileId = paymentProfiles.value[0]?.customerPaymentProfileId

    selectedPaymentProfileId.value = defaultProfileId || firstProfileId
  }
}

const select = async (customerPaymentProfileId: number) => {
  if (isInBilling) {
    await setDefault(customerPaymentProfileId)
    await loadSavedCustomerPaymentProfiles()
  }
  selectedPaymentProfileId.value = customerPaymentProfileId
}

const processPaymentProfile = (
  paymentProfile: TableViewPaymentProfile
): ComputedPaymentProfile => {
  return {
    customerPaymentProfileId: paymentProfile.customerPaymentProfileId,
    mask: paymentProfile.mask,
    typeLabel: paymentProfile.label,
    isDefault: paymentProfile.isDefault,
    accountHolderName: paymentProfile.accountHolderName,
    expiration: paymentProfile.expiration,
    address: {
      street1: paymentProfile.address?.street1,
      street2: paymentProfile.address?.street2,
      city: paymentProfile.address?.city,
      state: paymentProfile.address?.state,
      postalCode: paymentProfile.address?.postalCode,
      timeZone: paymentProfile.address?.timeZone,
      lat: paymentProfile.address?.lat,
      lng: paymentProfile.address?.lng,
      completeAddress: paymentProfile.address?.completeAddress,
      addressName: paymentProfile.address?.addressName,
    },
  }
}

const setDefault = async (customerPaymentProfileId: number) => {
  try {
    const payload = {
      customerId: auth.userId,
      customerPaymentProfileId,
    }
    await paymentProfileService.setDefault(payload)
  } catch (error) {
    console.error(error)
  }
}

return { __sfc: true,isInGuestCheckout, isInBilling, isLoading, props, emit, paymentProfiles, selectedPaymentProfileId, setPaymentProfiles, loadSavedCustomerPaymentProfiles, selectDefaultOrFirstPaymentProfile, select, processPaymentProfile, setDefault, PaymentProfileV2 }
}

})